import { render } from "./MikanHistory.vue?vue&type=template&id=5dabedd8&scoped=true"
import script from "./MikanHistory.vue?vue&type=script&lang=js"
export * from "./MikanHistory.vue?vue&type=script&lang=js"

import "./MikanHistory.vue?vue&type=style&index=0&id=5dabedd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dabedd8"]])

export default __exports__